// extracted by mini-css-extract-plugin
export default {"container":"EmailShareActivity_container__2QOZB"};